export const VENUE_STORAGE = 'SELECTED_CMS_VENUE';

export const USER_ROLES = {
  REGULAR_USER: 'regular_user',
  SUPER_USER: 'super_user',
  ADMINISTRATOR: 'admin',
  MEMBERDRAW_STAFF: 'memberdraw_staff',
  NONPUBLISH_USER: 'nonpublish_user'
};

export const PLAYLIST_STATUS = {
  DRAFT: 'Draft',
  PENDING: 'Pending Approval',
  PUBLISHED: 'Published'
};

export const VENUE_ASSETS_DEFAULT = {
  cms_logo: '/static/app-box-v2.png',
  dashboard_logo: '/static/transparency-02.png',
  dashboard_background: '/static/dashboard-bg.png',
  login_logo: '/static/app-box-v2.png'
};

export const USER_MENUS = {
  GAME_ADMIN: 'Game Admin',
  BANNER_CONFIG: 'Banner Config',
  APP_BUILDER: 'App Builder',
  PROMOTION: 'Promotion Management',
  PLAYER_PORTAL: 'Player Portal'
};

// export const USER_CUSTOMIZE_MENUS = Object.keys(USER_MENUS).map((key) => ({ key, value: USER_MENUS[key] }));
export const USER_CUSTOMIZE_MENUS = Object.keys(USER_MENUS)
  .map(key => USER_MENUS[key])
  .filter(item => item);

export const MENU_LIST = {
  DEVICES: 'Devices',
  GROUPS: 'Groups',
  ASSETS: 'Assets',
  PLAYLISTS: 'Playlists',
  SCHEDULES: 'Schedules',
  VENUES: 'Venues',
  SETTINGS: 'Settings',
  USER_PROFILE: 'User Profile',
  GAME_ADMIN: 'Game Admin',
  BANNER_CONFIG: 'Banner Config',
  APP_BUILDER: 'App Builder',
  PROMOTION: 'Promotion Management',
  PLAYER_PORTAL: 'Player Portal'
};



// WEBPACK FOOTER //
// ./src/constants/index.js